import { Box, Stack, Skeleton } from "@mui/material";
const GraphSkeletonForTrendsMob = () => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: "12px",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
        backgroundColor: "#fff",
        mb: 2,
      }}
    >
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Skeleton variant="text" width={220} height={24} />
        <Skeleton variant="rounded" width={70} height={32} />
      </Stack>

      {/* Chart Area */}
      <Skeleton variant="rounded" height={180} sx={{ borderRadius: "8px" }} />

      {/* X-axis labels */}
      <Stack direction="row" justifyContent="space-between" mt={2}>
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} variant="text" width={30} height={16} />
        ))}
      </Stack>
    </Box>
  );
};

export default GraphSkeletonForTrendsMob;
